import InstantSearch from 'vue-instantsearch';
import Utility from 'Utility';
import Vue from 'vue';
import _ from 'lodash';

import router from 'vue/routes';
import {store, Vuex} from 'vue/store';

import carousel from 'vue/common/carousel';
import dropdown from 'vue/common/dropdown';
import accordion from 'vue/common/accordion';
import vueStickySidebar from "vue-sticky-sidebar";
import dateRange from 'vue/common/dateRange';
import OrderHistory from 'vue/history/OrderHistory';
import OrderDetail from 'vue/history/OrderDetail';
import LineItems from 'vue/history/LineItems';
import TrackingNumber from 'vue/common/TrackingNumber';

//import breadcrumbs from 'vue/common/breadcrumbs';
import facets from 'vue/common/facets';
import confirmDelete from 'vue/common/confirm-delete';
import confirmCopy from 'vue/common/confirm-copy';
import submittalWidget from 'vue/common/submittal-widget';
import loading from 'vue/common/loading'
import saveButton from 'vue/common/save-button';
import shareProject from 'vue/common/share-project';
import leaveProject from 'vue/common/leave-project';
import FavoriteButton from 'vue/common/FavoriteButton';
import FavoriteButtonIcon from 'vue/common/FavoriteButtonIcon';
import SelectLink from 'vue/common/SelectLink';
import Descriptions from 'vue/products/descriptions';
import products from 'vue/products/index';
import productSubcategories from 'vue/products/product-subcategories';
import brandDescription from 'vue/products/brand-description';
import Brands from 'vue/products/brands';

import AppSearch from 'vue/AppSearch';

import resources from 'vue/resources/index';
import mechanicalSidebar from 'vue/submittal-manager/mechanical/sidebar/index';
import mechanicalHeader from 'vue/submittal-manager/mechanical/header/index';

import priceSheetMultipliers from 'vue/price-sheets/price-sheet-multipliers';

import AnvilSeismicApp from 'vue/submittal-manager/seismic-v1/app'; // Version 1 code works with the Anvil plugin
import SeismicSubmittalApp from 'vue/submittal-manager/seismic-v2/app'; // Version 2 code works with the SeismicSubmittal plugin

import rmaForm from 'vue/returns/rma-form';
import rmaLineItem from 'vue/returns/line-item';

import VepCalculator from 'vue/vep-calculator/VepCalculator';

//Algolia FE work
import productList from 'vue/products/product-list';
import selectProducts from 'vue/products/select-products';
import resultsFilter from 'vue/search/results-filter';
import TabAccordions from 'vue/common/TabAccordions';
import { SearchClient, SearchRouting, initializeAlgolia } from 'vue/AlgoliaSearch'
import noResults from 'vue/search/no-results'

Vue.use(InstantSearch);
//Vue.component('breadcrumbs', breadcrumbs);
Vue.component('carousel', carousel);
Vue.component('dropdown', dropdown);
Vue.component('accordion', accordion);
Vue.component('vue-sticky-sidebar', vueStickySidebar);
Vue.component('date-range', dateRange);
Vue.component('order-history', OrderHistory);
Vue.component('order-detail', OrderDetail);
Vue.component('line-items', LineItems);
Vue.component('tracking-number', TrackingNumber);
Vue.component('facets', facets);
//Vue.component('search', search);
Vue.component('descriptions', Descriptions);
Vue.component('brands', Brands);
Vue.component('product-subcategories', productSubcategories);
Vue.component('brand-description', brandDescription);
Vue.component('products', products);
//Vue.component('pages', Pages);

Vue.component('AppSearch', AppSearch);

Vue.component('resources', resources);
Vue.component('mechanical-sidebar', mechanicalSidebar);
Vue.component('mechanical-header', mechanicalHeader);
Vue.component('confirm-delete', confirmDelete);
Vue.component('confirm-copy', confirmCopy);
Vue.component('share-project', shareProject);
Vue.component('leave-project', leaveProject);
Vue.component('favorite-button', FavoriteButton);
Vue.component('favorite-button-icon', FavoriteButtonIcon);
Vue.component('select-link', SelectLink);
Vue.component('submittal-widget', submittalWidget);
Vue.component('loading', loading);
Vue.component('save-button', saveButton);
Vue.component('anvil-seismic-app', AnvilSeismicApp);
Vue.component('seismic-submital-app', SeismicSubmittalApp);
Vue.component('rma-form', rmaForm);
Vue.component('line-item', rmaLineItem);
Vue.component('tab-accordions', TabAccordions);
Vue.component('vep-calculator', VepCalculator);
Vue.component('price-sheet-multipliers', priceSheetMultipliers);

//Algolia FE work
Vue.component('select-products', selectProducts);
Vue.component('product-list', productList);
Vue.component('results-filter', resultsFilter);
Vue.component('no-results', noResults);


Vue.directive('click-outside', {
    bind: (el, binding, vnode) => {
        el.event = (event) => {
            // here I check that click was outside the el and his childrens

            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }

        };
        document.body.addEventListener('click', el.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.event)
    },
});

new Vue({

    data: {
        SearchClient,
        SearchRouting,
        queryString: null,
        resultsPerPage: 24,
        state: null,
        isUser: false,
    },
    el: '[data-app="app"]',
    beforeMount() {
        this.isUser = this.$el.dataset.user == "true" ? true : false;
    },
    mounted() {
        initializeAlgolia()
    },
    router,
    store
});
